export const clearLocalStorageExcept = (keysToKeep: string[] = []) => {
    const keepSet = new Set(keysToKeep);

    Object.keys(localStorage)
        .filter((key) => !keepSet.has(key))
        .forEach((key) => localStorage.removeItem(key));
};

export const setLocalStorageIfNotExists = (key: string, value: any) => {
    if (!localStorage.getItem(key)) {
        localStorage.setItem(key, JSON.stringify(value));
    }
};
